module.exports = __webpack_public_path__ + "img/alice.52d668e1.jpg";